import { AccountBalance } from '@mui/icons-material'
import { Box, Icon } from '@mui/material'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import React, { useRef, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { runMonthlyPayroll } from 'services/api/modules/payroll/payroll-dashboard'
import ErrorRunPayrollModal from './ErrorRunPayrollModal'
import PayrollPeriodModal from './PayrollPeriodModal'

const PayrollActionButton = ({ sx, ...rest }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const isModalOpenRef = useRef(false)
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleOpen = () => {
    isModalOpenRef.current = true
    setModalOpen(true)
  }
  const handleClose = () => {
    isModalOpenRef.current = false
    setModalOpen(false)
    setSelectValue('')
  }
  const [selectValue, setSelectValue] = useState('')
  const [isLoading, setIsLoadingCalculation] = useState(false)
  const runPeriodRef = useRef(null)
  const [promptErrors, setPromptErrors] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const refButton = useRef('button')
  const handleRunPayroll = () => {
    if (isLoading) return
    refButton.current.handleSubmit()
  }

  const { mutate: startPayroll } = useMutation(runMonthlyPayroll, {
    onSuccess: (res) => {
      const timeId = res?.data?.data?.time_id
      setIsLoadingCalculation(false)
      queryClient.invalidateQueries(['activeRun'])
      queryClient.invalidateQueries(['nonActiveRun'])

      if (isModalOpenRef.current && runPeriodRef.current && timeId) {
        navigate(
          `/app/payroll/regular-payroll/${runPeriodRef.current.monthRun}-${runPeriodRef.current.yearRun}`,
          {
            state: { fromDashboardButton: true, item: timeId },
          }
        )
      } else {
        runPeriodRef.current = null
      }
    },
    onError: (error) => {
      setErrorMessage(error?.data?.message)
      setPromptErrors(true)
      setIsLoadingCalculation(false)
    },
  })

  const handlePayrollSubmit = ({ month, year, value }) => {
    setIsLoadingCalculation(true)
    runPeriodRef.current = { monthRun: value, yearRun: year }
    startPayroll({ month: parseInt(month), year: parseInt(year) })
  }

  const handleCloseErrors = () => {
    setPromptErrors(false)
  }

  return (
    <Box
      sx={{
        '& .MuiBox-root': {
          boxSizing: 'border-box',
        },
        ...sx,
      }}
      {...rest}
    >
      <AdxActionButton
        title="Run Regular Payroll"
        description="Run a payroll following your regular schedule"
        icon={<AccountBalance />}
        sxIcon={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        iconColor="alternate.main"
        iconBgColor="alternate.light"
        actionMessage="Run"
        icon2="chevron_right"
        divClick={true}
        sxIcon2={{ lineHeight: '20px', height: '20px' }}
        onClick={handleOpen}
        sx={{
          border: 1,
          borderRadius: '4.5px',
          borderColor: 'gray-line.main',
          height: '100%',
        }}
      />
      <AdxFormModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        icon={<Icon>account_balance</Icon>}
        title="Run regular payroll"
        subtitle="Run a payroll following your regular schedule"
        enableFooter
        actionText="Run payroll"
        handleAction={handleRunPayroll}
        actionButtonDisabled={selectValue.payrollPeriod === ''}
        isLoading={isLoading}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          // sx={{
          //   minHeight: 'calc(70vh - 80px)',
          // }}
        >
          <PayrollPeriodModal
            setSelectValue={setSelectValue}
            onRunPayroll={handlePayrollSubmit}
            ref={refButton}
          />
          {/* <Box display="flex" justifyContent="center">
            <AdxButton variant={'ghost'} sx={{ padding: '0px 30px' }} onClick={handleClose}>
              Cancel
            </AdxButton>
            <AdxButton
              disabled={selectValue.payrollPeriod === ''}
              sx={{ width: 1 / 2 }}
              onClick={handleRunPayroll}
            >
              {isLoading ? (
                <>
                  <CircularProgress color="white" size={20} />
                </>
              ) : (
                <>Run payroll</>
              )}
            </AdxButton>
          </Box> */}
        </Box>
      </AdxFormModal>
      <ErrorRunPayrollModal
        isModalOpen={promptErrors}
        errorMessage={errorMessage}
        handleClose={handleCloseErrors}
      />
    </Box>
  )
}

export default PayrollActionButton
